import v1 from './class/v1';

const SDK = v1 as typeof v1 & { v1: typeof v1 };

SDK.v1 = v1;

declare global {
  interface Window {
    LeanxCC: typeof SDK;
  }
}

if (typeof window !== 'undefined') {
  (window as any).LeanxCC = SDK;
}

export default SDK;
